import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { formatMoney, SETTLEMENT_RESULT_META } from '../../services/expenseAccountsApi';

// Result of a settlement voucher against its advance (calculated by the server).
// No money is moved automatically: Accounts handles any recovery / additional payment.
const SettlementSummary = ({ settlement }) => {
  if (!settlement) return null;
  const meta = SETTLEMENT_RESULT_META[settlement.result] || { label: settlement.result, severity: 'info' };
  if (settlement.result === 'CURRENCY_MISMATCH') {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        <AlertTitle>Settlement of {settlement.advanceVoucherNumber}</AlertTitle>
        The advance ({settlement.advanceCurrency || '-'}) and the settlement ({settlement.currency || '-'}) use different currencies, so they cannot be compared.
      </Alert>
    );
  }
  const c = settlement.currency;
  return (
    <Alert severity={meta.severity} sx={{ mb: 2 }} data-testid="settlement-summary">
      <AlertTitle>Settlement of {settlement.advanceVoucherNumber}: {meta.label}</AlertTitle>
      Advance {formatMoney(settlement.advanceAmount, c)} · Settlement expenses {formatMoney(settlement.settlementAmount, c)}
      {settlement.result !== 'FULLY_SETTLED' && <> · <strong>{meta.label}: {formatMoney(settlement.difference, c)}</strong></>}
      {!settlement.settled && ' · (not yet submitted)'}
    </Alert>
  );
};

export default SettlementSummary;
